import React from 'react'
import PropTypes from 'prop-types'
import { prop } from 'ramda'
import { SearchAutoClearField } from 'storfox-form-fields'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'

import { getFullName } from '~/utils'
import Avatar from '~/components/Avatar'
import { Button } from '~/components/Buttons'
import * as API from '~/constants/api'

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const guid = prop('guid', item)
    const name = getFullName(item)
    const imagePath = prop('imagePath', item)

    return { id, guid, imagePath, name }
  }

  return null
}

function CustomerCreateSearchField ({ onChange, onClick, ...props }) {
  return (
    <Grid container={true} spacing={3}>
      <Grid item={true} xs={12} sm={7} lg={8}>
        <SearchAutoClearField
          data-cy="customer"
          name="customer"
          api={API.SALE_ORDER_CUSTOMER}
          placeholder="Search by customer name, email, phone number"
          getOptionValue={getOptionValue}
          onChange={onChange}
          renderOption={(props, option) => (
            <li {...props}>
              <Box display="flex" alignItems="center">
                <Avatar src={option.imagePath} alt={option.name} />
                <Box mr={2} />
                <Typography variant="body1">
                  {option.name}
                </Typography>
              </Box>
            </li>
          )}
          {...props}
        />
      </Grid>
      <Grid item={true} xs={12} sm={5} lg={4}>
        <Button
          variant="outlined"
          data-cy="new-customer"
          startIcon={<AddIcon />}
          onClick={onClick}
          fullWidth={true}
        >
          New customer
        </Button>
      </Grid>
    </Grid>
  )
}

CustomerCreateSearchField.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
}

export default CustomerCreateSearchField
